import { FunctionComponent, useEffect, useState } from "react";
import { QuestionIcon } from "@form/components/common/icons";
import { Textarea } from "@mantine/core";
import useVerifyCampaign from "@form/hooks/useVerifyCampaign";
import mixpanel from "mixpanel-browser";

import type { QuestiontForm } from "@form/components/form/modules/question";

const QuestionVerify: FunctionComponent<{
  quesion?: QuestiontForm;
  available: boolean;
  needVerify: boolean;
}> = ({ quesion, available, needVerify }) => {
  const { changeVerifyState, changeForm, form, result } =
    useVerifyCampaign(`question`);
  const [tracked, setTracked] = useState(false);

  const showError = needVerify && !result.question;

  useEffect(() => {
    changeVerifyState(!!form.question);
  }, [form.question]);

  return (
    <div className={available ? "" : "relative opacity-40 disable"}>
      <div className="flex items-center">
        <div className="flex-1">
          <div className="flex items-center">
            <QuestionIcon className="dark:fill-[#3C86FB]"></QuestionIcon>
            <span className="ml-2 font-bold text-body text-dark1 dark:text-gray_f9">
              Question
            </span>
          </div>
          <div className="mt-3 text-bodyS text-dark1 dark:text-gray_f9">
            <div>{quesion?.values?.question}</div>
          </div>
        </div>
      </div>
      <div className="relative">
        <Textarea
          readOnly={!available}
          value={form.question}
          className="mt-2"
          size="md"
          classNames={{
            input: `border-[#e7e7e7] dark:!bg-[#192844] dark:border-[#2F5EAA] ${
              showError ? "bg-error/10 border border-error" : ""
            }`,
          }}
          styles={{
            input: {
              minHeight: 75,
              paddingBottom: "30px!important",
            },
          }}
          disabled={!!form.id}
          maxLength={500}
          autosize={true}
          onChange={(e) => {
            changeForm(e.currentTarget.value);
            if (!tracked) {
              setTracked(true);
              mixpanel.track("input_answer");
            }
          }}
        ></Textarea>
        <div className="absolute right-5 bottom-3 text-bodyS dark:text-gray_f9">
          {form?.question?.length || 0}/500
        </div>
      </div>
      <div
        className={`text-error text-sm mt-1 ${showError ? "flex" : "hidden"}`}
      >
        This is required
      </div>
    </div>
  );
};

export default QuestionVerify;
